var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#EDF7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2093 16.0465H20.7907V19.6725L22.1405 21.0223L21.0223 22.1405L19.2093 20.3275V16.0465Z",
    fill: "#778189"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7989 21.9037C22.9901 21.7552 23.2525 21.7378 23.4616 21.8598L28.2058 24.6273C28.388 24.7336 28.5 24.9286 28.5 25.1395C28.5 25.3505 28.388 25.5454 28.2058 25.6517L23.4616 28.4192C23.2525 28.5412 22.9901 28.5238 22.7989 28.3753C22.6077 28.2267 22.526 27.9768 22.5925 27.7441L23.3367 25.1395L22.5925 22.5349C22.526 22.3022 22.6077 22.0523 22.7989 21.9037Z",
    fill: "#778189"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13.0455C16.1591 13.0455 13.0455 16.1591 13.0455 20C13.0455 23.8409 16.1591 26.9546 20 26.9546C20.2415 26.9546 20.4799 26.9422 20.7146 26.9184L20.8713 28.4558C20.5846 28.4851 20.2939 28.5 20 28.5C15.3056 28.5 11.5 24.6945 11.5 20C11.5 15.3056 15.3056 11.5 20 11.5C24.6945 11.5 28.5 15.3056 28.5 20C28.5 20.5812 28.4416 21.1495 28.33 21.6992L26.8154 21.3917C26.9066 20.9427 26.9546 20.4773 26.9546 20C26.9546 16.1591 23.8409 13.0455 20 13.0455Z",
    fill: "#778189"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheule);
export default __webpack_public_path__ + "static/media/scheule.e2e4615cba124cab810b1327044b6678.svg";
export { ForwardRef as ReactComponent };